import { defineMessages } from 'react-intl';

import { INTL_PREFIX } from '@/messages/const';

export const defined = defineMessages({
  title: {
    defaultMessage: 'Recently Viewed',
    id: `${INTL_PREFIX.COMMON}.recentlyViewed.title`,
  },
});
